import { ReactNode } from 'react';
import { useTranslation } from '@frontend/i18n';
import { SegmentedBar, type Data } from '@frontend/segmented-bar';
import { theme } from '@frontend/theme';
import { Heading, Text } from '@frontend/design-system';

type Props = {
  legendOptions: Data[];
  title?: ReactNode;
};
export const TrayHeader = ({ legendOptions, title }: Props) => {
  const { t } = useTranslation('bulk-messaging');

  return (
    <header>
      <Heading level={2} css={{ marginBottom: theme.spacing(1) }}>
        {title ?? t('Message Allotments')}
      </Heading>
      <Text>
        {t(
          'Manage your location allotment(s) for this send. Bulk message allotments will replenish at the beginning of each month.'
        )}
      </Text>
      <SegmentedBar items={legendOptions} css={{ marginTop: theme.spacing(2) }}>
        <SegmentedBar.Legend />
      </SegmentedBar>
    </header>
  );
};
